import React from 'react';

import styles from './gulch.scss';

const Gulch = () => <div className={styles.gulch}></div>;

export default Gulch;
